/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Residue } from './Residue';
import {
    ResidueFromJSON,
    ResidueFromJSONTyped,
    ResidueToJSON,
    ResidueToJSONTyped,
} from './Residue';

/**
 * 
 * @export
 * @interface ChainResidues
 */
export interface ChainResidues {
    /**
     * 
     * @type {string}
     * @memberof ChainResidues
     */
    chain: string;
    /**
     * 
     * @type {Array<Residue>}
     * @memberof ChainResidues
     */
    residues: Array<Residue>;
}

/**
 * Check if a given object implements the ChainResidues interface.
 */
export function instanceOfChainResidues(value: object): value is ChainResidues {
    if (!('chain' in value) || value['chain'] === undefined) return false;
    if (!('residues' in value) || value['residues'] === undefined) return false;
    return true;
}

export function ChainResiduesFromJSON(json: any): ChainResidues {
    return ChainResiduesFromJSONTyped(json, false);
}

export function ChainResiduesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChainResidues {
    if (json == null) {
        return json;
    }
    return {
        
        'chain': json['chain'],
        'residues': ((json['residues'] as Array<any>).map(ResidueFromJSON)),
    };
}

export function ChainResiduesToJSON(json: any): ChainResidues {
    return ChainResiduesToJSONTyped(json, false);
}

export function ChainResiduesToJSONTyped(value?: ChainResidues | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chain': value['chain'],
        'residues': ((value['residues'] as Array<any>).map(ResidueToJSON)),
    };
}

